import { createContext } from 'react';

const DayProgressContext = createContext();

export default DayProgressContext;
